export enum CommunityRoutes {
  DASHBOARD = "dashboard",
  USERS_VOICE = "users-voice",
  POLLS = "polls",
  FEEDBACK = "feedback",
  ANNOUNCEMENTS = "announcements",
}